<a [routerLink]="to">
  <ng-content></ng-content>
</a>
